(function(){
    'use strict';

    angular
    .module('appback')
    .controller('CuentaController', CuentaController)
 
    CuentaController.$inject = ["CuentaService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function CuentaController(CuentaService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this; 
        vm.type="cuenta";
       	console.log("hola");
       	vm.saveContenido = function(){
       		vm.loading=true;
       		console.log(vm);
            CuentaService.saveCampos(vm,function(data){
                window.location.href = "/backend/altcrm/content/view?type="+vm.type+"&id="+vm.id+"&lang_id=1";
            });
       	}
    }
  
})();